export const paymentMethodsQuery = `
query PaymentMethods($userId: String!) {
  paymentMethods(userId: $userId) {
    ... on CardPaymentMethod {
      id
      type
      cardExpiry
      cardHolder
      cardType
      maskedCardNumber
      token
    }
    ... on DebitPaymentMethod {
      id
      type
      accountLast4
      accountName
      accountBsb
    }
  }
}
`;

export const makePaymentMutation = `
mutation MakePayment($payment: PaymentInput!) {
  makePayment(payment: $payment) {
    status
    statusText
  }
}
`;

export const paymentMethodQuery = `
query PaymentMethod($id: String!, $userId: String!) {
  paymentMethod(id: $id, userId: $userId) {
    ... on CardPaymentMethod {
      id
      type
      cardExpiry
      cardHolder
      cardType
      maskedCardNumber
      token
    }
    ... on DebitPaymentMethod {
      id
      type
      accountLast4
      accountName
      accountBsb
    }
  }
}
`;

export const createPaymentMethodMutation = `
mutation CreatePaymentMethod($paymentMethod: PaymentMethodInput!) {
  createPaymentMethod(paymentMethod: $paymentMethod) {
    id
  }
}
`;